export default {
  goPremium: 'gp',
  linkWithAlexa: 'lwa',
};
